export default "__VITE_ASSET__f746ad5b__"